define('../app/fukit/view/block/pageable.table.view',['require','exports','module','backbone','uikit/uikit','./basic.table.view','../common/pagination.view','../common/simple.pagination.view','../../helpers/extend.util','../../collection/spf.collection'],function(require, exports, module) {
  //prettier-ignore
  var Backbone             = require('backbone'),
      UIKit                = require('uikit/uikit'),
      BasicTableView       = require('./basic.table.view'),
      PaginationView       = require('../common/pagination.view'),
      SimplePaginationView = require('../common/simple.pagination.view'),
      ExtendUtil           = require('../../helpers/extend.util'),
      SpfCollection        = require('../../collection/spf.collection');

  var PageableTableView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="tableView" /><ui name="paginationView" />';
    },

    options: {
      attached: false,
      simplePagination: false,
      alwaysShowEnds: false,
    },

    internalViewOptions: {
      tableView: ExtendUtil.extendOptionValueWithDefaults('table', function() {
        return {
          type: BasicTableView,
          collection: this.getOption('collection'),
          columns: this.columns,
        };
      }),
      paginationView: ExtendUtil.extendOptionValueWithDefaults('pagination', function() {
        //prettier-ignore
        var collection = this.collection,
            hasPaginateModel = collection && (collection.paginate instanceof Backbone.Model);
        return {
          type: this.getOption('simplePagination') ? SimplePaginationView : PaginationView,
          model: (hasPaginateModel ? collection.paginate : null) || new Backbone.Model(),
          alwaysShowEnds: this.getOption('alwaysShowEnds'),
        };
      }),
    },

    addColumn: function(column) {
      if (this.tableView) {
        this.tableView.columns.add(column);
      }
    },

    internalViewBindings: {
      tableView: {
        attached: 'attached',
        collection: 'collection',
      },
      paginationView: {
        collection: 'collection',
      },
    },
  });

  module.exports = PageableTableView;
});

